module.exports = __webpack_public_path__ + "static/media/banner-hot-deals-mobile.fec58325.jpg";